window.addEventListener("DOMContentLoaded", () => {
    document.documentElement.style.setProperty(
        "--header-height",
        document.querySelector("header").offsetHeight + "px"
    );
    accordion();
    tagsHeights();
});

window.addEventListener("resize", function () {
    document.documentElement.style.setProperty(
        "--header-height",
        document.querySelector("header").offsetHeight + "px"
    );
});

window.accordion = function () {
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            if (!this.classList.contains("current")) {
                var accordionTrigger = document.querySelectorAll(".accordion");
                var accordionPanel = document.querySelectorAll(".panel");
                for (i = 0; i < accordionTrigger.length; i++) {
                    accordionTrigger[i].classList.remove("_active");
                    accordionTrigger[i].classList.remove("current");
                }
                for (i = 0; i < accordionPanel.length; i++) {
                    accordionPanel[i].classList.remove("_active");
                    accordionPanel[i].classList.remove("current");
                }
            }

            this.classList.toggle("_active");
            this.classList.toggle("current");
            var panel = this.nextElementSibling;
            panel.classList.toggle("_active");
            panel.classList.toggle("current");
        });
    }
};

window.openTab = function (tabName) {
    var i;
    var tabTriggers = document.getElementsByClassName("tab-trigger");
    for (var i = 0; i < tabTriggers.length; i++) {
        tabTriggers[i].classList.remove("_active");
    }
    var tabs = document.getElementsByClassName("tab-item");
    for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove("_active");
    }
    var tab = document.getElementById(tabName);
    tab.classList.add("_active");
};

window.tagsHeights = function () {
    var maxAllow = 92;
    var ousia1Indications = document.querySelector("#tags-ousia1Indications");
    var ousia1 = document.querySelector("#tags-ousia1");
    var ousia2Indications = document.querySelector("#tags-ousia2Indications");
    var ousia2 = document.querySelector("#tags-ousia2");
    var drugDerivatives = document.querySelector("#tags-drugDerivatives");
    var drugDerivativesClone = document.querySelector("#tags-drugDerivatives-clone");
    var currentDrugMorph = document.querySelector("#tags-currentDrugMorph");
    var aneparkeia = document.querySelector("#tags-aneparkeia");
    var indications = document.querySelector("#tags-indications");
    var drugs = document.querySelector("#tags-drugs");
    var supplement = document.querySelector("#tags-supplement");

    if (ousia1Indications) {
        if(ousia1Indications.offsetHeight > maxAllow) {
            ousia1Indications.classList.add("_controlled");
        } else {
            getNextSibling(ousia1Indications, '.more-tags').classList.add("no-need");
        }
    }
    if (ousia1) {
        if(ousia1.offsetHeight > maxAllow) {
            ousia1.classList.add("_controlled");
        } else {
            getNextSibling(ousia1, '.more-tags').classList.add("no-need");
        }
    }
    if (ousia2Indications) {
        if(ousia2Indications.offsetHeight > maxAllow) {
            ousia2Indications.classList.add("_controlled");
        } else {
            getNextSibling(ousia2Indications, '.more-tags').classList.add("no-need");
        }
    }
    if (ousia2) {
        if(ousia2.offsetHeight > maxAllow) {
            ousia2.classList.add("_controlled");
        } else {
            getNextSibling(ousia2, '.more-tags').classList.add("no-need");
        }
    }
    if (drugDerivatives) {
        if(drugDerivatives.offsetHeight > maxAllow) {
            drugDerivatives.classList.add("_controlled");
        } else {
            getNextSibling(drugDerivatives, '.more-tags').classList.add("no-need");
        }
    }
    if (drugDerivativesClone) {
        if(drugDerivativesClone.offsetHeight > maxAllow) {
            drugDerivativesClone.classList.add("_controlled");
        } else {
            getNextSibling(drugDerivativesClone, '.more-tags-clone').classList.add("no-need");
        }
    }
    if (currentDrugMorph) {
        if(currentDrugMorph.offsetHeight > maxAllow) {
            currentDrugMorph.classList.add("_controlled");
        } else {
            getNextSibling(currentDrugMorph, '.more-tags').classList.add("no-need");
        }
    }
    if (aneparkeia) {
        if(aneparkeia.offsetHeight > maxAllow) {
            aneparkeia.classList.add("_controlled");
        } else {
            getNextSibling(aneparkeia, '.more-tags').classList.add("no-need");
        }
    }
    if (indications) {
        if(indications.offsetHeight > maxAllow) {
            indications.classList.add("_controlled");
        } else {
            getNextSibling(indications, '.more-tags').classList.add("no-need");
        }
    }
    if (drugs) {
        if(drugs.offsetHeight > maxAllow) {
            drugs.classList.add("_controlled");
        } else {
            getNextSibling(drugs, '.more-tags').classList.add("no-need");
        }
    }
    if (supplement) {
        if(supplement.offsetHeight > maxAllow) {
            supplement.classList.add("_controlled");
        } else {
            getNextSibling(supplement, '.more-tags').classList.add("no-need");
        }
    }
};

window.openTagWrap = function (openTagWrap) {
    var tagwrap = document.getElementById(openTagWrap);
    tagwrap.classList.toggle("_active");
};

window.contentSwap = function (contentSwap) {
    if (contentSwap.innerHTML === "Περισσότερα...") {
        contentSwap.innerHTML = "...Λιγότερα";
    } else {
        contentSwap.innerHTML = "Περισσότερα...";
    }
};

var getNextSibling = function (elem, selector) {
    var sibling = elem.nextElementSibling;
    if (!selector) return sibling;
    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }
};

// pricing plans page
$('.benefits-top').click(function(){
    $('.content-wrapper').slideToggle()
    $('.registration-form-wrapper').css('display', 'none')

    $('.desktop-view').toggleClass('details-open')
    $('.desktop-view').removeClass('form-open')
})

$('.mobile-subtitle-trigger').click(function(){
    $(this).siblings('.pricing-plan-wrapper-mob').slideToggle()
    $(this).siblings('.subscribe').toggleClass('open')
    $(this).siblings('.pricing-plan-wrapper-mob').toggleClass('open')
    $(this).toggleClass('open')
})

$('.subscribe').click(function(){
    $(this).siblings('.registration-form-wrapper').slideToggle()
    $('.mobile-view').toggleClass($(this).children('div')[0].id+'-open')
    $(this).siblings('.registration-form-wrapper').find('.radio-container-'+$(this).children('div')[0].id).click()

})

